import { CSSObject } from '@chakra-ui/react';

import { CustomButtonProps } from '@/components/Button/Button';

export const buttonRunnerPropositionButtonProps: CustomButtonProps = {
  w: '14',
  variant: 'odds',
};

export const favouriteFlexProps: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5',
  py: '0.5',
  width: 'calc(100% + 4px)',
  maxH: 'calc(var(--bc-space-3) + 2px)',
  marginRight: '-2px',
  marginLeft: '-2px',
  position: 'absolute',
  top: '-2px',
  borderTopLeftRadius: 'md',
  borderTopRightRadius: 'md',
  borderRight: '1px solid rgba(255, 255, 255, 0.10)',
  borderLeft: '1px solid rgba(255, 255, 255, 0.10)',
  bgGradient: 'linear(to-b, #FFE6B6, beta.500)',
};

export const favouriteIconProps: CSSObject = {
  boxSize: '2',
  color: 'beta.600',
};

export const favouriteTextProps: CSSObject = {
  fontSize: '2xs',
  color: 'beta.600',
  textShadow: 'none',
};
